import React, { createContext, useContext, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authAlias } from '../utils/comman/authHelper';

// Create the AuthContext
const AuthContext = createContext(null);

// AuthProvider component to wrap the app and provide auth state
export function AuthProvider({ children }) {
    const [user, setUser] = useState(localStorage.getItem(authAlias));

    // Simulate login function
    const login = (userData, callback) => {
        setUser(userData);
        callback();
    };

    // Simulate logout function
    const logout = (callback) => {
        setUser(null);
        callback();
    };

    const value = { user, login, logout, isAuthenticated: !!user };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

// Hook to use the AuthContext
export function useAuth() {
    return useContext(AuthContext);
}

// Component to protect routes that require authentication
export function RequireAuth({ children }) {
    const auth = useAuth();
    const location = useLocation();

    if (!auth.isAuthenticated) {
        // Redirect to login page, save the current location for redirect after login
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return children;
}
